import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { UnicodeEntity } from '@mews/enums';
import { Amount } from '@mews-commander/data-access';
import { SelectField } from '@mews-commander/form';
import { Taxation, TaxRateStrategyDiscriminator } from '@mews-commander/types';
import {
    getLocalizedTaxRatesOptions,
    getTaxationsByTaxEnvironmentCode,
} from '@mews-commander/legacy-entities/src/ducks/taxEnvironments';
import { useCommanderSelector } from '@mews-commander/utils';
import { ServiceOrderFormField } from '../schema';

interface TaxationFieldsOwnProps {
    name: string;
    readOnly?: boolean;
    id?: string;
    basePrice: Amount;
}

export const TaxationFields: React.FC<React.PropsWithChildren<TaxationFieldsOwnProps>> = ({
    name: fieldName,
    basePrice,
    ...other
}) => {
    const { taxEnvironmentCode } = useCurrentEnterprise();
    const taxations: Taxation[] = useCommanderSelector((state) =>
        getTaxationsByTaxEnvironmentCode(state, { taxEnvironmentCode })
    );

    if (!taxations.length) {
        return null;
    }

    return (
        <>
            {taxations.map(({ code, taxRates, name: taxationName }) => (
                <SelectField
                    key={code}
                    suffix={
                        taxRates[0].strategy.discriminator === TaxRateStrategyDiscriminator.Flat
                            ? taxRates[0].strategy.value.currencyCode
                            : UnicodeEntity.Percent
                    }
                    label={taxationName}
                    name={`${ServiceOrderFormField.TaxValues}.${code}`}
                    options={getLocalizedTaxRatesOptions(taxRates)}
                    showEmptyValue
                    {...other}
                />
            ))}
        </>
    );
};
